import React from 'react'
import { Row, Label, Column } from './styled'
import { SimpleSwitch } from '@sabavision/dio'
import { useTranslation } from 'react-i18next'
import { Istate } from '../../../reducers/types'
import { useSelector, useDispatch } from 'react-redux'
import { updateUserData } from '../../../actions/user'

function Notifications() {
  const { t } = useTranslation('translation', { keyPrefix: 'sidebar' })
  const dispatch = useDispatch()
  const user = useSelector((state: Istate) => state.user)

  const handleRequest = (name: 'sms' | 'email', value: boolean) => {
    dispatch(updateUserData({ unique_id: user.unique_id, [`prefer_receive_notifications_over_${name}`]: value }))
  }
  return (
    <Column>
      <Row className="space-between">
        <span>
          <Label className="label">{t('get_notification_with_sms')}</Label>
        </span>
        <SimpleSwitch
          value={user.prefer_receive_notifications_over_sms}
          handleToggle={(newValue) => {
            handleRequest('sms', newValue)
          }}
        />
      </Row>
      <Row className="space-between">
        <span>
          <Label>{t('get_notification_with_email')}</Label>
        </span>
        <SimpleSwitch
          value={user.prefer_receive_notifications_over_email}
          handleToggle={(newValue) => {
            handleRequest('email', newValue)
          }}
        />
      </Row>
    </Column>
  )
}

export default Notifications
